export default function changeImagesOnScroll() {
  const serviceItems = document.querySelectorAll('.services_item');
  const serviceImages = document.querySelector('.services_images_list');

  function changeImagesHandler() {
    if (!serviceImages || !serviceItems) return;

    const top = serviceImages.getBoundingClientRect().top,
          serviceImagesHeight = serviceImages.offsetHeight;
    let o = 0;

    serviceItems.forEach((i, l) => {
      i.getBoundingClientRect().top < top + serviceImagesHeight / 2 && (o = l)
    })

    serviceImages.querySelectorAll(".services_image").forEach((t, e) => {
      o === e ? t.classList.add("show") : t.classList.remove("show")
    })
  }

  function setImagesStickyPosition() {
    if (!serviceImages) return;
    const h = (document.querySelector('header').clientHeight);
    const t = (document.documentElement.clientHeight - serviceImages.offsetHeight) / 2;
    serviceImages.style.setProperty("--frontPageMockupsImagesTop", `${t + h}px`)
  }

  document.addEventListener('DOMContentLoaded', () => {
    changeImagesHandler();
    setImagesStickyPosition();
  })
  document.addEventListener('scroll', () => {
    changeImagesHandler();
    setImagesStickyPosition();
  })
  document.addEventListener('resize', () => {
    changeImagesHandler();
    setImagesStickyPosition();
  })
}